import CIcon from "@coreui/icons-react";
import { CSidebar, CSidebarBrand, CSidebarNav } from "@coreui/react";
import { sygnet } from "components/manager/assets/brand/sygnet";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
// sidebar nav config
import { ManagerSidebarNav } from "components/manager/ManagerSidebarNav";
import $ from "jquery";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useNavigate } from "react-router-dom";
import WorldvapeLogo from "resources/img/logo/worldvape_logo.svg";
import AdminSideBarNav from "routes/admin/AdminSideBarNav";
import { VendorReducer } from "shared/redux/reducers/vendor/VendorReducer";

function AdminSideBar() {
  const { isMobile } = useContext(BrowserDetectContext);
  const sidebar = useRef();
  const dispatch = useDispatch();
  const { sidebarShow, sidebarUnfoldable } = useSelector((state) => ({
    sidebarShow: state.vendor.sidebarShow,
    sidebarUnfoldable: state.vendor.sidebarUnfoldable,
  }));
  const [isVisible, setVisible] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    sidebar.current?.addEventListener("transitionend", onSidebarTransitionEnd);

    return () => {
      sidebar.current.removeEventListener(
        "transitionend",
        onSidebarTransitionEnd
      );
    };
  }, []);

  const onSidebarTransitionEnd = () => {
    let margin = $(".sidebar").outerWidth(true) - $(".sidebar").outerWidth();
    if (margin === 0) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    setVisible(sidebarShow);
  }, [sidebarShow]);

  useEffect(() => {
    if (isVisible === undefined) {
    } else {
      dispatch(VendorReducer.actions.toggleSideBar(isVisible));
    }
  }, [isVisible]);

  return (
    <CSidebar
      ref={sidebar}
      position="fixed"
      unfoldable={sidebarUnfoldable}
      visible={isMobile ? sidebarShow : true}
      style={{ width: !isMobile && 300 }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <div
          style={{
            width: "100%",
            // backgroundColor: "white",
            backgroundColor: "#F7570B",
            height: !isMobile && "128px",
          }}
        >
          <div
            style={{
              width: "90%",
              height: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={WorldvapeLogo}
              style={{ width: "200px", cursor: "pointer" }}
              // onClick={() => navigate("/")}
              // onMouseDown={(e) => {
              //   if (e.button === 1) {
              //     // navigate("/");
              //     window.open(window.location.origin, "_blank");
              //   }
              // }}
              onClick={() => navigate("/admin")}
              onMouseDown={(e) => {
                if (e.button === 1) {
                  window.open(window.location.origin + "/admin", "_blank");
                }
              }}
              alt="logo"
            />
          </div>
        </div>
        {/* <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} /> */}
        <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <ManagerSidebarNav items={AdminSideBarNav} />
        </SimpleBar>
      </CSidebarNav>
      {/* <CSidebarToggler className="d-none d-lg-flex" onClick={onSidebarTogglerClick} /> */}
    </CSidebar>
  );
}

// export default React.memo(VendorSidebar);
export default AdminSideBar;
